import { AfterViewInit, Component, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { InputComponent , InputComponent as InputComponent_1 } from "~app/common/components/input/input.component";
import { GridBaseComponent } from "../grid-base/grid-base.component";

import { ValidationRuleDirective } from "../../../../validation/validation-rule.directive";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "rask-grid-input-editor",
    templateUrl: "./grid-input-editor.component.html",
    styleUrls: ["./grid-input-editor.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent_1,
        ValidationRuleDirective,
        FormsModule
    ]
})
export class GridInputEditorComponent extends GridBaseComponent implements AfterViewInit {
    @ViewChild(InputComponent) comp: InputComponent;

    getValue(): any {
        return this.value;
    }

    ngAfterViewInit() {
        window.setTimeout(() => {
            this.comp.input.nativeElement.focus();
        });
    }

}
